export default class AchievementsStats {
  public id: string = "";
  public achievedAt: string = "";
}
